import EditUserPopUpView from './EditUserPopUp.view';
export * from './EditUserPopUp.view';

export const EditUserPopUp = (props) => EditUserPopUpView(props);

export default EditUserPopUp;

